import {makeGetHealthDateAuthorization} from 'main/factories/usecases';
import {DateFormatEnum} from 'presentation/constants';
import {formatDateString} from 'presentation/utils';

import {useGetExamAuthorizationMutation} from '../../mutations/useGetExamAuthorizationMutation';
import {useGetHealthSpecialtyAuthorizationMutation} from '../../mutations/useGetHealthSpecialtyAuthorizationMutation';
import {DateAuthorizationStateParams} from './types';

export function useBookingAuthorization() {
	const {mutateAsync: verifyExamAuthorization} = useGetExamAuthorizationMutation();

	const {mutateAsync: verifyHealthAuthorization} = useGetHealthSpecialtyAuthorizationMutation();

	async function verifyHealthDateAuthorization({
		flTipo,
		healthSelectedDate,
		healthSelectedSpecialty,
	}: DateAuthorizationStateParams) {
		const formattedDate = formatDateString(
			healthSelectedDate,
			'P',
			DateFormatEnum.DATE_FORMAT_5,
		).replace(/\//g, '');

		const response = await makeGetHealthDateAuthorization().get({
			dtConsulta: formattedDate,
			flTipo,
			speciality: String(healthSelectedSpecialty),
		});

		return response;
	}

	return {verifyExamAuthorization, verifyHealthAuthorization, verifyHealthDateAuthorization};
}
